import BackendClient from "../../BackendClient";
import axios from "axios";
import PlayersResponse from "../../models/player/PlayersResponse";

export function getPlayers(client: BackendClient, steamIdFilter: string, bohIdFilter: string, beGuidFilter: string, isPremiumFilter: boolean | null, profileFilter: string, pageSize: number, pageNumber: number): Promise<PlayersResponse> {
    const headers = {
      'Authorization': `${client.getAuthEntity()} ${client.getAuthToken()}`,
    };

    const params = `?filterSteamId=${encodeURIComponent(steamIdFilter)}&filterBohId=${encodeURIComponent(bohIdFilter)}&filterBeGuid=${encodeURIComponent(beGuidFilter)}&filterIsPremium=${isPremiumFilter}&filterProfile=${encodeURIComponent(profileFilter)}&paginationPageSize=${pageSize}&paginationPageNumber=${pageNumber}`;

    return new Promise<PlayersResponse>((resolve, reject) => {
      axios.get(`${client.getBackendUrl()}${BackendClient.ListPlayers}${params}`, {headers: headers})
        .then((response) => resolve(response.data))
        .catch((reason) => {
          console.log(`Exception when trying to get all players: ${JSON.stringify(reason)}`)
          reject(reason);
        });
    });
  }